import { styled, Select } from '@mui/material';

export const StyledMultiselect = styled(Select)`
  min-height: 50px !important;
  & .MuiOutlinedInput-input {
    padding: 9px 12px !important;
  }
`;
